import { MainInner } from "@/styles/global";
import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";

import S from "./TextRepeater.styled";

export interface Props {
  animation: string;
  title: string;
  texts: { text: string }[];
}

const TextRepeater: React.FC<Props> = ({ animation, texts, title }) => {
  const renderTexts = texts.map(({ text }, i) => {
    return <S.Text key={i}>{text}</S.Text>;
  });
  return (
    <AnimationOnScroll
      animateIn={`animate__${animation}`}
      animateOnce={true}
      initiallyVisible={animation == "none" ? true : false}
      duration={animation === "none" ? 0 : 1}
      delay={animation === "none" ? 0 : 100}
    >
      <MainInner>
        <S.Container>
          <S.Title>{title && title}</S.Title>
          <S.TextWrapper>{texts && renderTexts}</S.TextWrapper>
        </S.Container>
      </MainInner>
    </AnimationOnScroll>
  );
};

export default TextRepeater;
